export var AttackSourceTypeEnum;
(function (AttackSourceTypeEnum) {
    AttackSourceTypeEnum["ACTION"] = "ACTION";
    AttackSourceTypeEnum["ITEM"] = "ITEM";
    AttackSourceTypeEnum["SPELL"] = "SPELL";
    AttackSourceTypeEnum["CUSTOM"] = "CUSTOM";
})(AttackSourceTypeEnum || (AttackSourceTypeEnum = {}));
